import { audioAssetById, generatedAudioStatus } from '../data/foundations'

// Keep the canonical disk path stable but invalidate browser/CDN audio caches
// after an asset replacement. Playback and lesson preloading share this URL.
export function audioAssetUrl(assetId: string): string | undefined {
  const path = audioAssetById.get(assetId)?.path
  if (!path) return undefined
  const hash = generatedAudioStatus[assetId]?.sha256
  return hash ? `${path}?v=${hash}` : path
}
